export default [
  {
    name: 'Unsere Heimat',
    url: '#unsere-heimat',
  },
  {
    name: 'Unsere Zutaten',
    url: '#unsere-zutaten',
  },
  {
    name: 'Unser Verfahren',
    url: '#unser-verfahren',
  },
  {
    name: 'Unsere Empfehlung',
    url: '#unsere-empfehlung',
  },
  {
    name: 'Kontakt',
    url: '#kontakt',
  },
];
